import { useMemo } from "react"
import Icon from "src/shared/icons"
import { useDate } from "src/shared/hooks/useDate"
import { useTimePulse } from "src/shared/hooks/useTimePulse"
import RoomCardBody from "../../shared/RoomCardBody/RoomCardBody"
import RoomCardFooter from "../../shared/RoomCardFooter/RoomCardFooter"
import RoomCardHeader from "../../shared/RoomCardHeader/RoomCardHeader"
import Wrapper from "../../shared/Wrapper/Wrapper"
import ProgressBar from "../../shared/ProgressBar/ProgressBar"
import { RoomStatusProps } from "../../../../interfaces/RoomStatusProps.interface"
import { VENTA_EN_LINEA_DURATION_MS } from "../../../../constants/ventaEnLinea"
import { useVentaEnLineaFooter } from "../../../../hooks/useVentaEnLineaFooter"

import "./VentaEnLinea.css"

const VentaEnLinea = ({
    roomTypeName,
    roomNumber,
    occupiedTimeStart = "",
    hasIncidences,
    ventaEnLineaCodigo,
    ventaEnLineaComentario,
    occupiedTimeEndCondensada,
    room,
}: Omit<RoomStatusProps, "roomStatus">) => {
    const [now] = useTimePulse()
    const { UTCStringToLocalDate } = useDate()

    // Desde el registro de la última renta hasta la fecha_condensada de la última renta; sin ella se usa la duración por defecto
    const { timeStart, timeLimit } = useMemo(() => {
        const start = UTCStringToLocalDate(occupiedTimeStart)
        return {
            timeStart: start,
            timeLimit: occupiedTimeEndCondensada
                ? UTCStringToLocalDate(occupiedTimeEndCondensada)
                : new Date(start.getTime() + VENTA_EN_LINEA_DURATION_MS),
        }
    }, [occupiedTimeStart, occupiedTimeEndCondensada])
    // Se pasó la fecha_condensada sin hacer check in
    const isNoShow = !!occupiedTimeEndCondensada && now > timeLimit
    const {
        text: footerText,
        onSliderTriggered,
        withoutCardClick,
    } = useVentaEnLineaFooter({ room, isNoShow })

    return (
        <Wrapper>
            <RoomCardHeader
                hasIncidences={hasIncidences}
                iconBgColor="var(--purple-drawer-primario)"
                iconName="DoorOpenNew"
                roomNumber={roomNumber}
                roomTypeName={roomTypeName}
            />
            <RoomCardBody verticalAlign="center">
                {isNoShow ? (
                    <span className="room-card--mxl-venta-en-linea__label">Venta en línea</span>
                ) : (
                    <span className="room-card--mxl-venta-en-linea__codigo">Código: {ventaEnLineaCodigo || "-"}</span>
                )}
                {ventaEnLineaComentario && (
                    <div className="room-card--mxl-venta-en-linea__comentario-wrapper">
                        <Icon name="communication" color="var(--tipografa)" />
                        <span className="room-card--mxl-venta-en-linea__comentario">{ventaEnLineaComentario}</span>
                    </div>
                )}
                {isNoShow ? (
                    <span className="room-card--mxl-venta-en-linea__no-show">No show</span>
                ) : (
                    <div className="room-card--mxl-venta-en-linea__timer-wrapper">
                        <ProgressBar
                            timeValue={now}
                            timeStart={timeStart}
                            timeLimit={timeLimit}
                            alertTimerBgColor1={"var(--white)"}
                            alertTimerBgColor2={"var(--purple-drawer-primario)"}
                            alertTimerTextColor1={"var(--purple-drawer-primario)"}
                            alertTimerTextColor2={"var(--white)"}
                            valueBarBgColor={"var(--purple-drawer-primario)"}
                            totalTimeBarBgColor={"var(--gray-background)"}
                        />
                    </div>
                )}
            </RoomCardBody>
            {withoutCardClick(<RoomCardFooter text={footerText} onSliderTriggered={onSliderTriggered} />)}
        </Wrapper>
    )
}

export default VentaEnLinea
